<template>
  <div class="todo-page" :class="{ 'todo-page-light': $store.state.bgLight }">
    <div class="todo-toolbar">
      <div class="todo-category-options" role="group" aria-label="事项类别">
        <button v-for="category in categoryOptions" :key="category.value" type="button"
          class="todo-category-button" :class="{ 'is-active': selectedCategory === category.value }"
          :aria-pressed="selectedCategory === category.value" @click="handleCategoryChange(category.value)">
          {{ category.label }}
        </button>
      </div>
      <div class="todo-toolbar-actions">
        <a-input-search class="todo-title-search" v-model="queryParam.title" placeholder="搜索待办标题"
          allowClear @search="searchQuery" @change="handleTitleChange" />
        <a-popover v-model="filterVisible" trigger="click" placement="bottomRight"
          :overlayClassName="'todo-filter-overlay' + ($store.state.bgLight ? ' todo-filter-overlay-light' : '')">
          <div slot="content" class="todo-filter-panel">
            <div class="todo-filter-heading">筛选条件</div>
            <a-form layout="vertical">
              <a-form-item label="监测设施">
                <a-input v-model="queryParam.siteName" placeholder="请输入监测设施" allowClear @pressEnter="applyFilters" />
              </a-form-item>
              <a-form-item label="开始时间">
                <a-range-picker format="YYYY-MM-DD" v-model="dates.startTime" style="width: 100%"
                  :placeholder="['起始日期', '截止日期']" @change="onDateStartTime" />
              </a-form-item>
              <a-form-item label="设施类型">
                <j-dict-select-tag placeholder="请选择设施类型" dictCode="operation_type" v-model="queryParam.operationType" />
              </a-form-item>
            </a-form>
            <div class="todo-filter-actions">
              <a-button @click="resetAdvancedFilters">清除条件</a-button>
              <a-button type="primary" @click="applyFilters">应用筛选</a-button>
            </div>
          </div>
          <a-button icon="filter" :class="{ 'has-filters': advancedFilterCount > 0 }">
            筛选<span v-if="advancedFilterCount" class="todo-filter-count">{{ advancedFilterCount }}</span>
          </a-button>
        </a-popover>
        <a-button v-if="hasFilters" icon="reload" @click="searchReset">重置</a-button>
        <a-button v-if="isorter.order" @click="resetDefaultSort" title="恢复逾期优先的默认排序">默认排序</a-button>
      </div>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        :rowKey="record => record.originKey + ':' + record.id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <span slot="originKey" slot-scope="text, record">
          <template v-if="record.originKey === 'om_job_order'">
            <a-tag color="orange">运维工单</a-tag>
          </template>
          <template v-else-if="record.type === '10'">
            <a-tag color="purple">周期计划</a-tag>
          </template>
          <template v-else>
            <a-tag color="blue">工作计划</a-tag>
          </template>
        </span>

        <span slot="planTitle" slot-scope="text, record">
          <div>
            <a
              @click="handleDetail(record)"
              class="todo-title-link"
              :title="text"
            >
              {{ text || '无标题待办' }}
            </a>
            <a-tag v-if="record.type === '10'" color="purple" style="transform: scale(0.85); margin-left: 4px; vertical-align: middle;">周期</a-tag>
          </div>
          <!-- 计划包含的具体任务/明细展示 -->
          <div v-if="record.taskItems && record.taskItems.length > 0" class="todo-task-tags">
            <a-tag
              v-for="(item, index) in record.taskItems"
              :key="index"
              color="cyan"
              class="task-item-tag"
            >
              {{ formatTaskItem(item) }}
            </a-tag>
          </div>
          <!-- 工单说明/备注展示 -->
          <div v-else-if="record.remark" class="todo-remark-text" :title="record.remark">
            <a-icon type="file-text" style="margin-right: 4px; color: #8c8c8c;" />{{ record.remark }}
          </div>
        </span>

        <span slot="facility" slot-scope="text, record" :title="record.siteName">
          <a-tag size="small" :color="record.operationType == '2' ? 'cyan' : 'blue'" style="margin-right: 4px;">
            {{ record.operationType_dictText || (record.operationType == '2' ? '管网' : '站点') }}
          </a-tag>
          <span style="font-weight: 500; color: #333;">{{ record.siteName || '-' }}</span>
        </span>

        <span slot="planPeriod" slot-scope="text, record">
          <div style="font-size: 12px; color: #555; line-height: 1.6;">
            <a-icon type="clock-circle" style="color: #1890ff; margin-right: 4px;" />始：{{ formatPeriodTime(record.startTime) }}
          </div>
          <div style="font-size: 12px; color: #555; line-height: 1.6;">
            <a-icon type="clock-circle" style="color: #fa8c16; margin-right: 4px;" />止：{{ formatPeriodTime(record.endTime) }}
            <a-tag v-if="isOverdue(record)" color="red" style="transform: scale(0.85); margin-left: 2px;">已逾期</a-tag>
            <a-tag v-else-if="isUpcoming(record)" color="blue" style="transform: scale(0.85); margin-left: 2px;">未开始</a-tag>
            <a-tag v-else-if="isDueToday(record)" color="orange" style="transform: scale(0.85); margin-left: 2px;">今日到期</a-tag>
          </div>
        </span>

        <span slot="action" slot-scope="text, record">
          <a-button type="primary" size="small" ghost @click="handleDetail(record)">
            办理
          </a-button>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->
    <work-plan-modal ref="workPlan" @ok="modalFormOk"></work-plan-modal>
    <YongchunJobOrderDrawer v-if="tenantCode=='yongchun'" ref="jobOrder" :pagePath="pagePath2" @ok="modalFormOk"></YongchunJobOrderDrawer>
    <jobOrder-drawer v-else ref="jobOrder" :pagePath="pagePath2" @ok="modalFormOk"></jobOrder-drawer>
    <!-- 表单区域 -->
  </div>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JobOrderDrawer from '../job/modules/JobOrderDrawer'
import YongchunJobOrderDrawer from "../job/modules/YongchunJobOrderDrawer"
import WorkPlanModal from './modules/WorkPlanModal.vue'
import { getAction } from '@/api/manage'
import { initDictOptions, filterDictText } from '@/components/dict/JDictSelectUtil'
import moment from 'moment'

export default {
  name: 'TodoList',
  mixins: [JeecgListMixin],
  components: { WorkPlanModal, JobOrderDrawer, YongchunJobOrderDrawer },
  data() {
    return {
      pagePath2: '/om/job/order',
      pagePath: '/om/sys/todo',
      pageTitle: '待办事项',
      tenantCode: '',
      selectedCategory: '',
      listRequestId: 0,
      filterVisible: false,
      planTitleDictOptions: [],
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 55,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          dataIndex: 'originKey',
          colName: 'origin_key',
          title: '事项类别',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'originKey' },
        },
        {
          dataIndex: 'title',
          colName: 'title',
          title: '待办标题 / 任务内容',
          align: 'left',
          width: 260,
          scopedSlots: { customRender: 'planTitle' },
        },
        {
          dataIndex: 'siteName',
          colName: 'site_id',
          title: '设施 / 站点',
          align: 'left',
          width: 170,
          scopedSlots: { customRender: 'facility' },
        },
        {
          dataIndex: 'startTime',
          colName: 'start_time',
          title: '日程周期 / 办理时限',
          align: 'left',
          width: 200,
          sorter: true,
          sortOrder: null,
          scopedSlots: { customRender: 'planPeriod' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 90,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        plan: '/om/work/plan/',
        job: '/om/job/order/',
      },
    }
  },
  computed: {
    advancedFilterCount() {
      return [this.queryParam.siteName, this.queryParam.operationType,
        this.queryParam.startTimeStart || this.queryParam.startTimeEnd].filter(Boolean).length
    },
    hasFilters() {
      return !!(this.selectedCategory || this.queryParam.title || this.advancedFilterCount)
    },
    categoryOptions() {
      return [
        { label: '全部事项', value: '' },
        { label: '全部计划', value: 'om_work_plan' },
        { label: '周期计划', value: 'cycle_plan' },
        { label: '常规计划', value: 'manual_plan' },
        { label: '运维工单', value: 'om_job_order' },
      ].filter(category => this.tenantCode !== 'yongchun' || category.value !== 'om_job_order')
    },
  },
  created() {
    this.tenantCode = window.localStorage.getItem('projectCode')
    initDictOptions('plan_title').then((res) => {
      if (res && res.success && Array.isArray(res.result)) {
        this.planTitleDictOptions = res.result
      }
    })
  },
  mounted() {
    setTimeout(() => {
      this.$bus.$emit('showSite', 'show', false)
      this.$bus.$emit('isCheckbox', 'show', false)
    }, 300)
  },
  methods: {
    applyFilters() {
      this.filterVisible = false
      this.loadData(1)
    },
    resetAdvancedFilters() {
      this.queryParam = Object.assign({}, this.queryParam, {
        siteName: undefined, operationType: undefined, startTimeStart: undefined, startTimeEnd: undefined,
      })
      this.dates = {}
      this.applyFilters()
    },
    handleTitleChange(event) {
      if (!event.target.value) this.loadData(1)
    },
    initTableData(arg) {
      if (arg === 1) this.ipagination.current = 1
      const requestId = ++this.listRequestId
      this.loading = true
      return getAction(this.pagePath, this.getQueryParams()).then(res => {
        // 快速切换类别时，只接收最后一次查询，避免旧结果覆盖当前列表。
        if (requestId !== this.listRequestId) return
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
          this.loadNums++
        } else {
          this.$message.warning(res.message || '获取待办事项失败')
        }
      }).finally(() => {
        if (requestId === this.listRequestId) this.loading = false
      })
    },
    formatTaskItem(item) {
      if (!item) return ''
      if (this.planTitleDictOptions && this.planTitleDictOptions.length > 0) {
        const text = filterDictText(this.planTitleDictOptions, String(item))
        if (text) return text
      }
      return item
    },
    onDateStartTime: function (value, dateArray) {
      this.queryParam.startTimeStart = dateArray[0]
      this.queryParam.startTimeEnd = dateArray[1]
    },
    onDateEndTime: function (value, dateArray) {
      this.queryParam.endTimeStart = dateArray[0]
      this.queryParam.endTimeEnd = dateArray[1]
    },
    formatPeriodTime(timeStr) {
      if (!timeStr) return '-'
      return timeStr.length > 16 ? timeStr.substring(0, 16) : timeStr
    },
    isOverdue(record) {
      if (!record || !record.endTime) return false
      return moment(record.endTime).isBefore(moment())
    },
    isUpcoming(record) {
      return !!(record && record.startTime && moment(record.startTime).isAfter(moment()))
    },
    isDueToday(record) {
      return !!(record && record.endTime && moment(record.endTime).isSame(moment(), 'day'))
    },
    handleTableChange(pagination, filters, sorter) {
      const order = sorter && sorter.order
      const timeColumn = this.columns.find(column => column.dataIndex === 'startTime')
      const previousOrder = timeColumn.sortOrder
      this.isorter = order ? { column: 'start_time', order: order === 'ascend' ? 'asc' : 'desc' } : {}
      timeColumn.sortOrder = order || null
      this.ipagination = Object.assign({}, pagination, { current: (order || null) === previousOrder ? pagination.current : 1 })
      this.loadData()
    },
    resetDefaultSort() {
      this.isorter = {}
      this.columns.find(column => column.dataIndex === 'startTime').sortOrder = null
      this.loadData(1)
    },
    handleCategoryChange(val) {
      this.selectedCategory = val
      if (val === 'cycle_plan') {
        this.queryParam.originKey = 'om_work_plan'
        this.queryParam.type = '10'
      } else if (val === 'manual_plan') {
        this.queryParam.originKey = 'om_work_plan'
        this.queryParam.type = '1'
      } else if (val === 'om_work_plan') {
        this.queryParam.originKey = 'om_work_plan'
        this.queryParam.type = undefined
      } else if (val === 'om_job_order') {
        this.queryParam.originKey = 'om_job_order'
        this.queryParam.type = undefined
      } else {
        this.queryParam.originKey = undefined
        this.queryParam.type = undefined
      }
      this.loadData(1)
    },
    searchReset() {
      this.filterVisible = false
      this.selectedCategory = ''
      this.queryParam = {}
      this.dates = {}
      this.resetDefaultSort()
    },
    handleCheck(record) {
      this.handleDetail(record)
    },
    handleDetail(record) {
      if (record.originKey === 'om_work_tasks' || record.originKey === 'om_work_plan') {
        getAction(this.url.plan + record.id).then((res) => {
          if (res.success) {
            this.$refs.workPlan.disableSubmit = true
            this.$refs.workPlan.edit(res.result)
            this.$refs.workPlan.title = res.result && res.result.type === '10' ? '办理：周期计划' : '办理：工作计划'
          } else {
            this.$message.error(res.message || '获取工作计划详情失败')
          }
        }).catch(() => {
          this.$message.error('获取工作计划详情失败')
        })
      } else if (record.originKey === 'om_job_order') {
        getAction(this.url.job + record.id).then((res) => {
          if (res.success) {
            const userId = this.$store.getters.userInfo.id
            if (userId == null || res.result.userId == null || String(res.result.userId) !== String(userId)) {
              this.$message.warning('您不是该工单的处理人，无法办理')
              this.loadData()
              return
            }
            this.$refs.jobOrder.title = '办理：运维工单'
            this.$refs.jobOrder.disableSubmit = false
            this.$refs.jobOrder.showCheck = true
            this.$refs.jobOrder.showEdit = true
            this.$refs.jobOrder.edit(res.result)
          } else {
            this.$message.error(res.message || '获取工单详情失败')
          }
        }).catch(() => {
          this.$message.error('获取工单详情失败')
        })
      } else {
        this.$message.warning('未知的待办事项类别：' + (record.originKey_dictText || record.originKey))
      }
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';

.todo-page {
  --todo-text: #e7effc;
  --todo-muted: #b4c5df;
  --todo-surface: rgba(255, 255, 255, 0.06);
  --todo-border: rgba(255, 255, 255, 0.18);
  --todo-selected: rgba(69, 157, 255, 0.20);
  --todo-accent: #95ccff;
  --todo-glow: rgba(62, 157, 255, 0.28);
}
.todo-page-light {
  --todo-text: #26364a;
  --todo-muted: #65758a;
  --todo-surface: #fff;
  --todo-border: #dbe3ed;
  --todo-selected: #eaf4ff;
  --todo-accent: #1677dd;
  --todo-glow: rgba(22, 119, 221, 0.14);
}
.todo-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px 16px;
  padding: 4px 0;
  margin-bottom: 10px;
}
.todo-category-options {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.todo-category-button {
  padding: 6px 15px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: var(--todo-muted);
  line-height: 22px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s, border-color 0.15s, box-shadow 0.15s;
}
.todo-category-button:hover {
  background: var(--todo-surface);
  color: var(--todo-text);
}
.todo-category-button.is-active {
  background: var(--todo-selected);
  color: var(--todo-accent);
  border-color: var(--todo-accent);
  box-shadow: 0 0 10px var(--todo-glow);
  font-weight: 600;
}
.todo-category-button:focus-visible {
  outline: 2px solid var(--todo-accent);
  outline-offset: 2px;
}
.todo-toolbar-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.todo-title-search {
  width: 240px;
}
.todo-toolbar-actions >>> .ant-input {
  color: var(--todo-text);
  background: var(--todo-surface);
  border-color: var(--todo-border);
  border-radius: 6px;
}
.todo-toolbar-actions >>> .ant-input::placeholder,
.todo-toolbar-actions >>> .ant-input-search-icon,
.todo-toolbar-actions >>> .ant-input-clear-icon {
  color: var(--todo-muted);
}
.todo-toolbar-actions .ant-btn {
  margin-right: 0;
  border-radius: 6px;
}
.todo-toolbar-actions .ant-btn-default {
  color: var(--todo-muted);
  background: transparent;
  border-color: var(--todo-border);
}
.todo-toolbar-actions .has-filters {
  color: var(--todo-accent);
  border-color: var(--todo-accent);
}
.todo-filter-count {
  margin-left: 6px;
  font-size: 12px;
}
@media (max-width: 767px) {
  .todo-category-options {
    flex-wrap: nowrap;
    overflow-x: auto;
    width: 100%;
  }
  .todo-category-button {
    flex-shrink: 0;
  }
  .todo-title-search {
    width: 200px;
  }
}

.todo-title-link {
  font-size: 14px;
  font-weight: 600;
  color: #1890ff;
  cursor: pointer;
  transition: color 0.2s ease;
  display: inline-block;
  margin-bottom: 2px;
}
.todo-title-link:hover {
  color: #40a9ff;
  text-decoration: underline;
}

.todo-task-tags {
  margin-top: 4px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.task-item-tag {
  margin: 0;
  font-size: 12px;
  border-radius: 4px;
  line-height: 20px;
}

.todo-remark-text {
  margin-top: 4px;
  font-size: 12px;
  color: #8c8c8c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 250px;
}
</style>
<style>
.todo-filter-overlay .ant-popover-inner,
.todo-filter-overlay .ant-popover-arrow {
  background-color: #1b3a6b;
}
.todo-filter-overlay .ant-popover-inner {
  border-radius: 10px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.25);
}
.todo-filter-panel {
  width: 300px;
  max-width: calc(100vw - 64px);
  padding: 4px;
  color: #e7effc;
}
.todo-filter-heading {
  margin-bottom: 14px;
  font-weight: 600;
}
.todo-filter-panel .ant-form-item {
  margin-bottom: 14px;
}
.todo-filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 4px;
}
.todo-filter-overlay-light .ant-popover-inner,
.todo-filter-overlay-light .ant-popover-arrow {
  background-color: #fff;
}
.todo-filter-overlay-light .todo-filter-panel {
  color: #26364a;
}
.todo-filter-overlay-light .ant-form-item-label > label {
  color: #26364a !important;
}
</style>
